import "./../styles.scss";

import { notification, Select } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import { editClient } from "../../../utils/validations";

const EditClient = ({ ...props }) => {
  const { Option } = Select;
  const firstRef = useRef(true);
  const secRef = useRef(true);
  const {
    editmodalOpen,
    setEditModalOpen,
    tenantDetails,
    tenantNames,
    usersDetails,
    setUsersDetails,
    updateTenant,
    getTenants,
    getUserDetail,
    setUserSearch,
  } = props;
  const [selectedUser, setSelectedUser] = useState([]);
  const [count, setCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [initialValues, setInitialValues] = useState({
    name: tenantDetails?.name,
    associateUsers: tenantDetails?._id,
  });
  const closeModal = () => {
    setEditModalOpen(false);
    const users = [];
    const userIds = [];
    tenantDetails?.users?.length !== 0 &&
      tenantDetails?.users?.map((alluser) => {
        userIds.push(alluser.userId);
        users.push({
          value: alluser.userId,
          label: `${alluser.name}-${alluser.email}`,
        });
      });
    setSelectedUser(userIds);
  };

  useEffect(() => {
    const users = [];
    const userIds = [];
    tenantDetails?.users?.length !== 0 &&
      tenantDetails?.users?.map((alluser) => {
        userIds.push(alluser.userId);
        users.push({
          value: alluser.userId,
          label: `${alluser.name}-${alluser.email}`,
        });
      });
    setSelectedUser(userIds);

    setInitialValues({
      ...initialValues,
      name: tenantDetails?.name,
      _id: tenantDetails?._id,
      users: users,
    });
  }, [tenantDetails]);
  //Edit existing folder
  const handleSubmit = async ({ name }) => {
    if (tenantNames.filter((e) => e._id !== initialValues?._id && e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Client Name Already Exists" });
    } else {
      const payload = {
        id: tenantDetails?._id,
        associateUsers: selectedUser,
        name,
        createdBy: localStorage.getItem("__uid"),
      };
      const data = await updateTenant(payload);
      if (data.value.success || data.value.status) {
        notification["success"]({ message: data.value.message });
      } else {
        notification["error"]({ message: data.value.message });
      }
      getTenants();
      closeModal();
    }
  };

  const editTenantName = (e, setFieldValue) => {
    setFieldValue(e, "name");
    setInitialValues({ ...initialValues, name: e });
  };

  const setSubClientUserName = (value, setFieldValue) => {
    setSelectedUser(value);
    setFieldValue("users", value);
    setUserSearch(value);
  };
  const search = async () => {
    const data = await getUserDetail({ search: searchText });
    if (data.value.success) {
      const filterUser = data.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      setUsersDetails(filterUser);
    }
  };
  useEffect(() => {
    if (firstRef.current) {
      search();
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        search();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);
  useEffect(() => {
    if (secRef.current) {
      secRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [searchText, setCount]);
  return (
    <>
      <Modal
        isOpen={editmodalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Client Name</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={editClient}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Client Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                        value={initialValues?.name}
                        onChange={(e) => editTenantName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Select users<span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          showSearch
                          className="custom-ant-select"
                          name="users"
                          onChange={(value) => setSubClientUserName(value, setFieldValue)}
                          component={Select}
                          mode="multiple"
                          placeholder="Select Users"
                          filterOption={false}
                          dropdownStyle={{ zIndex: 99999999 }}
                          onSearch={(inputValue) => setSearchText(inputValue)}
                          value={selectedUser}
                        >
                          {usersDetails.length &&
                            usersDetails.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.userId} data={data}>
                                    {data.name}-{data.email}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.users && errors.users && <div className="invalid-feedback">{errors.users}</div>}
                      </div>
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Edit
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditClient;
